import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';
import { CBTransactionInfoResultDto } from '../../common/cb-transaction-info-result-dto';

export class APCreditApplicationResultDto {
    creditApplicationId: number;
    @Type(() => CBTransactionInfoResultDto)
    source: CBTransactionInfoResultDto;
    @Type(() => CBTransactionInfoResultDto)
    target: CBTransactionInfoResultDto;
    amount: number;
    @Type(() => Date)
    appliedDate: Date;
    @Type(() => UserNameDisplayResultDto)
    updatedBy: UserNameDisplayResultDto;
    subLedger: string;
    @Type(() => Date)
    reversalDate: Date;
    reversalDescription: string;
    allowUnapply: boolean;

    get updatedByDisplayText(): string {
        return Utils.notNullAndDefined(this.updatedBy) ? this.updatedBy.displayName : '';
    }
}
